import { gql } from '@apollo/client'

export const TENANT_BOOKING_PERMISSION_QUERY = gql`
  query TenantBookingPermission($input: TenantBookingPermissionInput!) {
    tenantBookingPermission(input: $input) {
      accommodationId
      accommodationName
      channelType
      actionType
      allowOperation
      allowDiscount
      reservationType
    }
  }
`

export const UPDATE_TENANT_BOOKING_PERMISSION_MUTATION = gql`
  mutation UpdateTenantBookingPermission(
    $input: [UpdateBookingPermissionInput!]!
  ) {
    updateTenantBookingPermission(input: $input) {
      message
    }
  }
`
